module.exports = __webpack_public_path__ + "cd455783/img/delete-icon.eb7de062.svg";